import ApplicationsHistory from './ApplicationsHistory';
export default ApplicationsHistory;
